import { CandidateStatusGroupEnum } from '@constants';

export const buildDisableOptionAndTooltipsTitleByOptionType = ({
  isNotEmpty,
  group,
  isAutomation,
  hrmId,
  isOutsideHrm,
}: {
  isNotEmpty: boolean;
  group: CandidateStatusGroupEnum;
  isAutomation?: boolean;
  hrmId?: number;
  isOutsideHrm?: boolean;
}): string | null => {
  if (group === CandidateStatusGroupEnum.OFFER && !isNotEmpty) {
    // АС-21.1 - 21.3
    return 'tooltips.proposalNotCreated';
  }

  if (!isOutsideHrm && isAutomation) {
    // АС-21.4.1
    return 'tooltips.automaticallyStatus';
  }

  if (!isOutsideHrm && group === CandidateStatusGroupEnum.JOB_ENTRY && !hrmId) {
    // АС-21.4.2
    return 'tooltips.profileIsNotDefined';
  }

  return null;
};
